import type { UploadBusinessLine } from "ray-logger-report";
import { isDev } from "./env";

const LOG_UPLOAD_WINDOW_MS = 5 * 60 * 1000;
const LOGGER_UPLOAD_BASE_URL = {
  test: "http://10.51.154.48:8443",
  prod: "https://logger.rayvision.com:10443",
} as const;

export type LoggerBusinessLine = UploadBusinessLine | "renderbus";
export interface LoggerUploadOptions {
  businessLine?: LoggerBusinessLine;
  userId?: number;
  remark?: string;
  sinceMs?: number;
}

export function getLoggerBaseUrl(): string {
  return isDev() ? LOGGER_UPLOAD_BASE_URL.test : LOGGER_UPLOAD_BASE_URL.prod;
}

export function getLoggerBusinessLine(): LoggerBusinessLine {
  return "renderbus";
}

export function normalizeUploadLogOptions(
  options?: LoggerUploadOptions
): Required<LoggerUploadOptions> {
  return {
    businessLine: options?.businessLine ?? getLoggerBusinessLine(),
    userId: options?.userId ?? 0,
    remark: options?.remark ?? "",
    sinceMs: options?.sinceMs ?? Date.now() - LOG_UPLOAD_WINDOW_MS,
  };
}
